/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'galax/config/route/unit.create.list';


export default class extends Base
{
  isRouteVisible ()
  {
    return super.isRouteVisible() && this.isUnitTypeFound();
  }


  isRouteDisabled ()
  {
    return super.isRouteDisabled();
  }


  isRouteActivated ()
  {
    return super.isRouteActivated();
  }


  isUnitTypeFound ()
  {
    return this.galaxy.getConstants().getUnit(this.args.type) != null;
  }


};
